export const settingsLocations = {
  accountSettings: 'account',
  userManagement: 'users',
  userCreate: 'users/create',
  userEdit: 'users/:userId/edit',
  notificationPreferences: 'notification-preferences',
  applicationPreferences: 'application-preferences',
};
